const SET_CURRENT_QUOTE = "SET_CURRENT_QUOTE";
const SET_CURRENT_USER = "SET_CURRENT_USER";
const SET_USER_SETTINGS = "SET_USER_SETTINGS";
const SET_GLOBAL_SETTINGS = "SET_GLOBAL_SETTINGS";

export { SET_CURRENT_QUOTE, SET_CURRENT_USER, SET_USER_SETTINGS, SET_GLOBAL_SETTINGS};
